import React from "react"

const AboutRecruiterSection = ({ about }) => {
  if (!about || (!about.title && !about.text)) {
    return null
  }
  return (
    <section className="py-7 text-center border-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="section-title">{about.title}</h2>
            <p>{about.text}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutRecruiterSection
